export default __webpack_public_path__ + "static/media/qr-code-placeholder.5d77aa77.png";